import { lazy } from 'react';
import urlPath from 'src/constants/urlPath';
import { PermissionEn } from '@martech-solution/utils/constants';
import MainLayout from 'src/layouts/MainLayout';
import EmployeeCompensation from 'src/pages/Hr/EmployeeCompensation';
import type { RouteGroup } from '@martech-solution/utils/types';

// Lazy load components
const BiometricDevice = lazy(() => import('src/pages/Hr/BiometricDevice'));
const BiometricLog = lazy(() => import('src/pages/Hr/BiometricLog'));
const BiometricEmployeeMapping = lazy(() => import('src/pages/Hr/BiometricEmployeeMapping'));
const BiometricDeviceDownloadLog = lazy(() => import('src/pages/Hr/BiometricDeviceDownloadLog'));
const EmployeeShift = lazy(() => import('src/pages/Hr/EmployeeShift'));
const AdvancePaymentEmployee = lazy(() => import('src/pages/Hr/AdvancePaymentEmployee'));
const LeaveTicketPackage = lazy(() => import('src/pages/Hr/LeaveTicketPackage'));
const AddLeaveTicketPackage = lazy(() => import('src/pages/Hr/AddLeaveTicketPackage'));
const LeaveTicketPackageDetail = lazy(() => import('src/pages/Hr/LeaveTicketPackageDetail'));
const Timesheet = lazy(() => import('src/pages/Hr/Timesheet'));
const AdditionalWorkingTimePackage = lazy(() => import('src/pages/Hr/AdditionalWorkingTimePackage'));
const AdditionalWorkingTimePackageDetail = lazy(() => import('src/pages/Hr/AdditionalWorkingTimePackageDetail'));
const AdvancePaymentLimit = lazy(() => import('src/pages/Hr/AdvancePaymentLimit'));
const EmployeeEvaluation = lazy(() => import('src/pages/Hr/EmployeeEvaluation'));
const LeaveRemainingYear = lazy(() => import('src/pages/v2/HrTicket/LeaveRemainingYear'));

export const hrRoutes: RouteGroup = [
  // Biometric System
  {
    path: urlPath.biometricLog.location,
    Layout: MainLayout,
    Component: BiometricLog
  },
  {
    path: urlPath.biometricEmployeeMapping.location,
    Layout: MainLayout,
    Component: BiometricEmployeeMapping,
    checkPath: urlPath.biometricEmployeeMapping.location
  },
  {
    path: urlPath.biometricDevice.location,
    Layout: MainLayout,
    Component: BiometricDevice,
    checkPath: urlPath.biometricDevice.location
  },
  {
    path: urlPath.biometricDeviceDownloadLog.location,
    Layout: MainLayout,
    Component: BiometricDeviceDownloadLog,
    checkPath: urlPath.biometricDeviceDownloadLog.location
  },

  // Leave Management
  {
    path: urlPath.leaveRemainingYear.location,
    Layout: MainLayout,
    Component: LeaveRemainingYear,
    checkPath: urlPath.leaveRemainingYear.location
  },
  {
    path: urlPath.leaveTicketPackage.location,
    Layout: MainLayout,
    Component: LeaveTicketPackage,
    checkPath: urlPath.leaveTicketPackage.location
  },
  {
    path: urlPath.leaveTicketPackageAdd.location,
    Layout: MainLayout,
    Component: AddLeaveTicketPackage,
    permission: PermissionEn.create
  },
  {
    path: `${urlPath.leaveTicketPackageDetail.location}/:id`,
    Layout: MainLayout,
    Component: LeaveTicketPackageDetail,
    permission: PermissionEn.viewDetail
  },

  // Working Time Management
  {
    path: urlPath.additionalWorkingTimePackage.location,
    Layout: MainLayout,
    Component: AdditionalWorkingTimePackage,
    checkPath: urlPath.additionalWorkingTimePackage.location
  },
  {
    path: `${urlPath.additionalWorkingTimePackageDetail.location}/:id`,
    Layout: MainLayout,
    Component: AdditionalWorkingTimePackageDetail,
    permission: PermissionEn.viewDetail
  },
  {
    path: urlPath.timesheet.location,
    Layout: MainLayout,
    Component: Timesheet,
    checkPath: urlPath.timesheet.location
  },
  {
    path: urlPath.employeeShift.location,
    Layout: MainLayout,
    Component: EmployeeShift,
    checkPath: urlPath.employeeShift.location
  },

  // Financial Management
  {
    path: urlPath.advancePaymentEmployee.location,
    Layout: MainLayout,
    Component: AdvancePaymentEmployee,
    checkPath: urlPath.advancePaymentEmployee.location
  },
  {
    path: urlPath.advancePaymentLimit.location,
    Layout: MainLayout,
    Component: AdvancePaymentLimit,
    checkPath: urlPath.advancePaymentLimit.location
  },
  {
    path: urlPath.employeeCompensation.location,
    Layout: MainLayout,
    Component: EmployeeCompensation,
    permission: PermissionEn.create
  },

  // Employee Performance
  {
    path: urlPath.employeeEvaluation.location,
    Layout: MainLayout,
    Component: EmployeeEvaluation,
    checkPath: urlPath.employeeEvaluation.location
  }
];
